export default __webpack_public_path__ + "331140d8025c7228dd412264435435c5.svg";